import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportError } from '../lib/errorReport';

/** Bắt lỗi khi vẽ giao diện: thay vì màn hình trắng, hiện thông báo thân thiện và tự báo lỗi cho quản trị. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportError('react', error, (info.componentStack || '').trim().split('\n').slice(0, 4).join(' ← '));
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="soon-box" role="alert" style={{ margin: '48px auto' }}>
        <h3>Có lỗi xảy ra</h3>
        <p>Rất tiếc, màn hình này gặp sự cố. Lỗi đã được tự động báo cho quản trị. Dữ liệu của bạn không bị mất.</p>
        <div><button type="button" className="btn primary" onClick={() => location.reload()}>Tải lại trang</button></div>
      </div>
    );
  }
}
